import { Outlet } from "react-router-dom"
import { AppLayout as AppLayoutComponent } from "@components/Layout/AppLayout/AppLayout"

/**
 * Layout wrapper that provides navbar with dynamic titles
 *
 * Child pages can pass navbarTitle via context or props
 * For now, supports automatic title extraction from routes
 * Future: child pages can provide custom navbarTitle via context
 */
export function AppLayout() {
   return (
      <AppLayoutComponent showNavbar={true}>
         <Outlet />
      </AppLayoutComponent>
   )
}
